<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :delete_url="delete_url"
      :urls="urls"
    />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import EditItem from "@/own/components/stores/contacts/EditItem";
import {
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/contacts.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "Accounts",
  components: { DataTable },
  data: () => ({
    componentForEditing: EditItem,
    delete_url: `/stores/portal/contacts/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
    },
    store_names: {
      getTableFilters: "getCONTACTSTableFilters",
      getTableState: "getCONTACTSTableState",
      getTableData: "getCONTACTSTableData",
      getTableHeaders: "getCONTACTSTableHeaders",
      getTableProperties: "getCONTACTSTableProperties",
      getTableExportUrl: "getCONTACTSExportUrl",
      getTablePermissions: "getCONTACTSTablePermissions",
    },
    urls: {
      delete: `/stores/portal/contacts/destroy`,
      status: `/stores/portal/contacts/status`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
